// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Site_UnidadeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** ResponseContract for GET /site/v1/unidades/{slug}?locale= */
import type { Site_UnidadeRow } from './Site_UnidadeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Site_UnidadeResponseDados {
unidade: Site_UnidadeRow
locale: string
}

export type Site_UnidadeResponse = ApiResponse<Site_UnidadeResponseDados>;

registerResponseContract('Site_UnidadeResponse', {
  unidade: {
    type: 'object',
    required: true,
    fields: {
      id:                   { type: 'number',  required: true },
      franquia_id:          { type: 'number',  required: false },
      slug:                 { type: 'string',  required: true },
      nome:                 { type: 'string',  required: true },
      endereco:             { type: 'string',  required: false },
      whatsapp:             { type: 'string',  required: false },
      whatsapp_sem_tracos:  { type: 'string',  required: false },
      instagram:            { type: 'string',  required: false },
      facebook:             { type: 'string',  required: false },
      tiktok:               { type: 'string',  required: false },
      estado:               { type: 'string',  required: false },
      cidade:               { type: 'string',  required: false },
      pais:                 { type: 'string',  required: false },
      status:               { type: 'string',  required: false },
      latitude:             { type: 'number',  required: false },
      longitude:            { type: 'number',  required: false },
      imagem_url:           { type: 'string',  required: false },
      imagem_alt:           { type: 'string',  required: false },
      galeria: {
        type: 'array',
        required: false,
        items: {
          foto_url: { type: 'string',  required: true },
          foto_alt: { type: 'string',  required: false },
        },
      },
      cidades_atendidas:    { type: 'array',   required: false },
      bairros_atendidos:    { type: 'array',   required: false },
      horario_semana_abre:  { type: 'string',  required: false },
      horario_semana_fecha: { type: 'string',  required: false },
      horario_sabado_abre:  { type: 'string',  required: false },
      horario_sabado_fecha: { type: 'string',  required: false },
      updated_at:           { type: 'string',  required: false },
      tracking: {
        type: 'object',
        required: false,
        fields: {
          google_ads_ids: { type: 'array',   required: false },
          meta_pixel:     { type: 'string',  required: false },
          gtm_extra:      { type: 'string',  required: false },
        },
      },
    },
  },
  locale: { type: 'string',  required: true },
})
